<template>
  <div>
    <main id="main">
      <contentSection />
    </main>
  </div>
</template>

<script>
/* eslint-disable */
import contentSection from "./contentSection";
import Log from "../../../assets/Log";

export default {
  components: {
    contentSection
  },

  created() {
    if (!Log.getPerson().name) {
      this.$router.push({
        name: "Login",
        params: {
          page: {
            pageRedirect: "/property/list",
            text: "Please Login or Register to add a property"
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
